import { updateSettingsWorkplaceLocationApi as generatedUpdateSettingsWorkplaceLocationApi } from '../generated/settingsWorkplaces/updateSettingsWorkplaceLocation';

const updateSettingsWorkplaceLocationApi = generatedUpdateSettingsWorkplaceLocationApi.enhanceEndpoints({
  endpoints: {
    updateSettingsWorkplaceLocation: {
      invalidatesTags: ['SettingsWorkplaces'],
    },
  },
});

export const { useUpdateSettingsWorkplaceLocationMutation } = updateSettingsWorkplaceLocationApi;
